/* ===================================================================
   Derman Collection — Hediye Kampanya Bar'ı v3
   Sepet TUTARINI dinler (kırlent adedi yerine).

   Kademeler:
     1.100 ₺  →  Runner (hediye)
     2.499 ₺  →  Paspas (hediye)

   Hediye tespiti TUTAR üzerinden yapılır: sepetteki 0₺ satırlar
   toplama dahil edilmez. Dr Free Gift hediyeyi 0₺ unlisted ürün
   olarak eklediği için variant ID takibine gerek yok.

   theme.liquid içinde </body> etiketinden hemen önce:
   <script>  ...bu dosyanın içeriği...  </script>
   =================================================================== */
(function () {
  "use strict";

  /* ---------------- AYARLAR ---------------------------------------- */

  // Eşikler — KURUŞ cinsinden (1.100,00 ₺ = 110000)
  var STEP1 = 110000;
  var STEP2 = 249900;

  // Kademe isimleri (metinlerde kullanılır)
  var STEP1_NAME = "Runner";
  var STEP2_NAME = "Paspas";

  // HEDİYE SATIRLARI — sepet toplamına SAYILMAZ.
  // Dr Free Gift, hediyeyi 0₺ fiyatlı UNLISTED bir ürün olarak sepete ekler.
  // Bu yüzden variant/product ID'ye değil, TUTARA bakıyoruz: 0₺ satır = hediye.
  // (Uygulama hediye ürününü değiştirse bile kod bozulmaz.)

  // İstisna gerekirse buraya variant ID ekleyin (normalde boş kalmalı):
  var EXCLUDE_VARIANT_IDS = [];

  // Konfeti: 1 = sadece son kademede, 2 = her iki kademede
  var CONFETTI_MODE = 2;

  /* ---------------- YARDIMCILAR ------------------------------------ */

  var nf2 = new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  var nf0 = new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 0 });

  function money(cents) {
    var v = cents / 100;
    return "₺" + (cents % 100 === 0 ? nf0.format(v) : nf2.format(v));
  }

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  }

  // Satır tutarı (indirimler uygulanmış)
  function lineTotal(it) {
    if (typeof it.final_line_price === "number") return it.final_line_price;
    if (typeof it.line_price === "number") return it.line_price;
    return (it.price || 0) * (it.quantity || 0);
  }

  // Hediye mi? → Tutar 0 ise hediyedir.
  function isGift(it) {
    if (EXCLUDE_VARIANT_IDS.indexOf(it.variant_id) !== -1) return true;
    if (it.price === 0) return true;        // 0₺ unlisted hediye ürünü
    if (lineTotal(it) === 0) return true;   // %100 indirimle 0'a düşenler
    return false;
  }

  // Hediyeler hariç sepet toplamı
  function eligibleTotal(cart) {
    var t = 0;
    (cart.items || []).forEach(function (it) {
      if (!isGift(it)) t += lineTotal(it);
    });
    return t;
  }

  // Kademeli (segment) doluluk: 1.100₺ = %50, 2.499₺ = %100.
  // Böylece mevcut CSS'teki milestone konumları (%50 / %100) bozulmaz.
  function pctFor(total) {
    if (total <= 0) return 0;
    if (total < STEP1) return (total / STEP1) * 50;
    if (total < STEP2) return 50 + ((total - STEP1) / (STEP2 - STEP1)) * 50;
    return 100;
  }

  /* ---------------- KONFETİ ---------------------------------------- */

  function confettiBurst(el) {
    var box = el.querySelector(".dc-confetti");
    if (!box) return;
    box.innerHTML = "";
    var shades = ["#000", "#222", "#444", "#666", "#999"];
    for (var i = 0; i < 22; i++) {
      var p = document.createElement("i");
      p.style.left = Math.round(Math.random() * 100) + "%";
      p.style.top = "-10px";
      p.style.animationDelay = (Math.random() * 120) + "ms";
      p.style.background = shades[Math.floor(Math.random() * shades.length)];
      p.style.width = (6 + Math.floor(Math.random() * 6)) + "px";
      p.style.height = (8 + Math.floor(Math.random() * 10)) + "px";
      box.appendChild(p);
    }
    setTimeout(function () { box.innerHTML = ""; }, 1200);
  }

  /* ---------------- RENDER ----------------------------------------- */

  var armed1 = true, armed2 = true;
  var lastCart = null;

  function renderOne(el, total) {
    var textEl = el.querySelector(".dc-cm-text");
    var fillEl = el.querySelector(".dc-cm-fill");
    var has1 = total >= STEP1;
    var has2 = total >= STEP2;

    if (fillEl) fillEl.style.width = pctFor(total).toFixed(1) + "%";

    el.classList.toggle("is-step1", has1);
    el.classList.toggle("is-step2", has2);

    if (textEl) {
      if (!has1) {
        textEl.textContent = STEP1_NAME + " hediyeniz için " + money(STEP1 - total) + " kaldı";
      } else if (!has2) {
        textEl.textContent = STEP2_NAME + " hediyeniz için " + money(STEP2 - total) + " kaldı";
      } else {
        textEl.textContent = "Tüm hediyeleriniz sepette 🎉";
      }
    }
  }

  function applyCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    lastCart = cart;

    var total = eligibleTotal(cart);
    var bars = document.querySelectorAll(".dc-campaign-mini");
    if (!bars.length) return;

    // Eşiğin altına düşülünce konfeti tekrar kurulur
    if (total < STEP1) armed1 = true;
    if (total < STEP2) armed2 = true;

    var hide = total <= 0;

    Array.prototype.forEach.call(bars, function (el) {
      if (hide) {
        el.style.display = "none";
        el.classList.remove("is-step1", "is-step2");
      } else {
        el.style.display = "block";
        renderOne(el, total);
      }
    });

    if (hide) return;

    if (total >= STEP2 && armed2) {
      armed2 = false; armed1 = false;
      Array.prototype.forEach.call(bars, confettiBurst);
    } else if (CONFETTI_MODE === 2 && total >= STEP1 && armed1) {
      armed1 = false;
      Array.prototype.forEach.call(bars, confettiBurst);
    }
  }

  /* ---------------- SEPET OKUMA ------------------------------------ */

  var pending = null;

  function loadCart() {
    if (pending) return pending;
    pending = fetch(root() + "cart.js", {
      headers: { "Accept": "application/json" },
      credentials: "same-origin"
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { pending = null; applyCart(c); return c; })
      .catch(function () { pending = null; });
    return pending;
  }

  var timer = null;
  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(loadCart, delay == null ? 120 : delay);
  }

  /* ---------------- AJAX YAKALAMA ---------------------------------- */

  var CART_RE = /\/cart(\/(add|change|update|clear))?(\.js|\.json)(\?|$)/i;

  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function () {
      var args = arguments;
      var p = origFetch.apply(this, args);
      try {
        var a0 = args[0];
        var url = (typeof a0 === "string") ? a0 : (a0 && a0.url) || "";
        if (CART_RE.test(url)) {
          p.then(function (res) {
            try {
              res.clone().json().then(function (data) {
                // Yanıt tam sepet nesnesiyse ekstra istek atmadan kullan
                if (data && Array.isArray(data.items) && typeof data.total_price === "number") {
                  applyCart(data);
                } else {
                  schedule();
                }
              }).catch(function () { schedule(); });
            } catch (e) { schedule(); }
          }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) {
    this.__dcUrl = u;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var self = this;
    this.addEventListener("loadend", function () {
      if (CART_RE.test(self.__dcUrl || "")) schedule(150);
    });
    return origSend.apply(this, arguments);
  };

  /* ---------------- BAŞLATMA --------------------------------------- */

  function init() {
    loadCart();

    // Tema event'leri
    [
      "cart:updated", "cart:refresh", "cart:change", "cart:build",
      "ajaxCart.afterCartLoad", "cart-drawer:open", "CartDrawer:open"
    ].forEach(function (evt) {
      document.addEventListener(evt, function () { schedule(80); });
    });

    document.addEventListener("click", function () { schedule(400); }, true);
    document.addEventListener("change", function () { schedule(400); }, true);

    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) schedule(200);
    });
    window.addEventListener("pageshow", function () { schedule(200); });

    // Drawer sonradan render olduğunda bar'ı anında doldur (flicker olmasın)
    var mo = new MutationObserver(function (muts) {
      var sawBar = false;
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.classList && n.classList.contains("dc-campaign-mini")) { sawBar = true; break; }
          if (n.querySelector && n.querySelector(".dc-campaign-mini")) { sawBar = true; break; }
        }
        if (sawBar) break;
      }
      if (sawBar && lastCart) applyCart(lastCart);
      schedule(250);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Konsoldan test için: DCHediyeBar.refresh()
  window.DCHediyeBar = { refresh: loadCart, cart: function () { return lastCart; } };
})();